import { ref, shallowRef } from 'vue'
import type { EndpointConfig } from './EndpointConfig.types'

/**
 * Query-based endpoint config: fetches from GET /api/aria/endpoint-config
 * and exposes reactive refs. CollectionRegistry uses this when runtime
 * config / env do not provide reactiveDbShapeUrl.
 */
export function useEndpointContext() {
  const data = shallowRef<EndpointConfig | undefined>(undefined)
  const isPending = ref(true)
  const error = ref<unknown>(null)

  function fetchConfig() {
    isPending.value = true
    error.value = null
    return $fetch<EndpointConfig>('/api/aria/endpoint-config')
      .then((payload) => {
        data.value = payload
        return payload
      })
      .catch((e) => {
        error.value = e
        data.value = undefined
      })
      .finally(() => {
        isPending.value = false
      })
  }

  if (import.meta.client) fetchConfig()

  return {
    data,
    isPending,
    error,
    refetch: fetchConfig,
  }
}
